(function() { window.GUID_6cde1844_9ee1_4915_9185_2626a4b00acb = { getGuid: function() { return "6cde1844-9ee1-4915-9185-2626a4b00acb"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class VideoPlayer extends Controls.ControlBase {
            constructor() {
                super(...arguments);
                this.videoVolumeChange = (e) => {
                    this.videoMuteChange();
                };
                this.durationchange = (e) => {
                    if (this.video.duration > 0)
                        this.Progress.updateDuration();
                };
                this.videoTimeupdated = (e) => {
                    requestAnimationFrame(() => {
                        this.Progress.updateProgress();
                    });
                };
                //Playback has stopped because the end of the media was reached.
                this.videoEnded = (videoEnded) => {
                    this.container.removeClass("playing");
                };
                //Playback has been paused.
                this.videoPaused = (e) => {
                    this.container.removeClass("playing");
                    this.container.addClass("paused");
                };
                //Playback has begun.
                this.videoPlaying = (e) => {
                    this.container.addClass("playing");
                    this.container.removeClass("paused");
                };
                //Playback is ready to start after having been paused or delayed due to lack of data.
                this.videoIsReady = (e) => { };
                //Playback has stopped because of a temporary lack of data
                this.videoWaiting = (e) => { };
                this.buttonClick = (e, a) => {
                    var clicked = $(e.currentTarget);
                    switch (clicked.data("action")) {
                        case "play":
                            this.PlayPause();
                            break;
                        case "stop":
                            this.video.pause();
                            this.video.currentTime = 0;
                            break;
                        case "mute":
                            this.video.muted = !this.video.muted;
                            this.videoMuteChange();
                            break;
                        case "voldown":
                            this.videoAlterVolume("-");
                            break;
                        case "volup":
                            this.videoAlterVolume("+");
                            break;
                        case "chapiter":
                            this.Chapiter.ChapiterMenuButtonClick(e);
                            break;
                        default:
                    }
                };
                this.isStarted = false;
                this.offEvents = new Array();
            }
            get ControlId() {
                return this.container.attr("id");
            }
            get $Control() {
                return this.container;
            }
            OnControlInstantiation(params) {
                const me = this;
                this.baseInternals = new Array();
                this.setEventRaiser();
                this.container = $(params[0]);
                this.buttons = this.container.find(".controls .buttons button");
                this.controls = this.container.find(".controls");
                var video = this.container.find("video");
                if (video.length > 0) {
                    this.video = video[0];
                }
                var $fullScreenButton = this.$Control.find('.controls .buttons .fs');
                this.fullScreenButton = $fullScreenButton[0];
                this.Chapiters = this.container.data("chapiters");
                this.Elements = new Controls.VideoPlayerInternals.Elements(this);
                this.ProgressTouch = new Controls.VideoPlayerInternals.ProgressTouch(this);
                this.FullScreen = new Controls.VideoPlayerInternals.Fullscreen(this);
                this.Progress = new Controls.VideoPlayerInternals.VideoProgress(this);
                this.videoTouched = new Controls.VideoPlayerInternals.TouchedVideo(this);
                this.videoThumbnail = new Controls.VideoPlayerInternals.Thumbnail(this.video.src);
                this.Chapiter = new Controls.VideoPlayerInternals.Chapiter(this);
                if (!this.FullScreen.FullScreenEnabled) {
                    $fullScreenButton.hide();
                }
            }
            static GetInstance(selector) {
                return Controls.GetInstance(VideoPlayer, selector);
            }
            get IsPlaying() {
                return !!(this.video.currentTime > 0 && !this.video.paused && !this.video.ended && this.video.readyState > 2);
            }
            PlayPause() {
                if (!this.IsPlaying) {
                    this.videoStart();
                    this.video.play();
                }
                else {
                    this.video.pause();
                }
            }
            videoAlterVolume(dir, delta = 0.1) {
                if (dir) {
                    var currentVolume = Math.floor(this.video.volume * 10) / 10;
                    if (dir === '+') {
                        if (currentVolume < 1)
                            this.video.volume += 0.1;
                    }
                    else if (dir === '-') {
                        if (currentVolume > 0)
                            this.video.volume -= 0.1;
                    }
                    // If the volume has been turned off, also set it as muted
                    // Note: can only do this with the custom control set as when the 'volumechange' event is raised, there is no way to know if it was via a volume or a mute change
                    if (currentVolume <= 0)
                        this.video.muted = true;
                    else
                        this.video.muted = false;
                    this.videoMuteChange();
                }
            }
            videoMuteChange() {
                if (this.video.muted)
                    this.container.addClass("muted");
                else
                    this.container.removeClass("muted");
            }
            Seek(seconds) {
                if (this.video.fastSeek)
                    this.video.fastSeek(Math.floor(seconds));
                else
                    this.video.currentTime = Math.floor(seconds);
            }
            OnBindEvents() {
                const me = this;
                this.event(this.fullScreenButton)
                    .offon('click', this.FullScreen.ToggleFullscreen);
                this.event(this.buttons)
                    .offon('click', this.buttonClick);
                this.event(this.video)
                    .offon("timeupdate", this.videoTimeupdated)
                    .offon("ended", this.videoEnded)
                    .offon("pause", this.videoPaused)
                    .offon("play", this.videoPlaying)
                    .offon("playing", this.videoIsReady)
                    .offon("waiting", this.videoWaiting)
                    .offon('volumechange', this.videoVolumeChange, false);
                //Bind event on all internal classes
                this.callInternals((i) => { i.OnBindEvents(); });
            }
            videoStart() {
                if (!this.isStarted) {
                    this.container.addClass("started");
                    this.isStarted = true;
                }
            }
            OnDispose() {
                this.callInternals((i) => { i.Dispose(); });
                if (this.offEvents && this.offEvents.length > 0)
                    for (var i = 0; i < this.offEvents.length; i++) {
                        this.offEvents[i]();
                    }
                this.$Control.remove();
            }
            setEventRaiser() {
                this.eventRaiser = {
                    ChapiterMenuToggle: (jqe, data) => { this.Trigger(EventNames.ChapiterMenuToggle, { jqueryEventObject: jqe, data }); },
                    ChapitersLoaded: (jqe, data) => { this.Trigger(EventNames.ChapitersLoaded, { jqueryEventObject: jqe, data }); },
                    ControlsVisibilityChange: (jqe, data) => { this.Trigger(EventNames.ControlsVisibilityChange, { jqueryEventObject: jqe, data }); },
                    ControlsVisibilityChanged: (jqe, data) => { this.Trigger(EventNames.ControlsVisibilityChanged, { jqueryEventObject: jqe, data }); },
                    FullscreenChange: (jqe, data) => { this.Trigger(EventNames.FullscreenChange, { jqueryEventObject: jqe, data }); },
                    VideoLoaded: (jqe, data) => { this.Trigger(EventNames.VideoLoaded, { jqueryEventObject: jqe, data }); }
                };
            }
            jqEventChain(element, off) {
                return {
                    element: element,
                    offon: (event, callback) => {
                        let ue = event + "." + this.UniqueNamespace;
                        element.offon(ue, callback);
                        var nOff = () => {
                            element.off(ue, callback);
                        };
                        this.offEvents.push(nOff);
                        return this.jqEventChain(element, nOff);
                    },
                    offonSelector: (event, selector, callback) => {
                        let ue = event + "." + this.UniqueNamespace;
                        element.offon(ue, selector, callback);
                        var nOff = () => {
                            element.off(ue, selector);
                        };
                        this.offEvents.push(nOff);
                        return this.jqEventChain(element, nOff);
                    },
                    off: off,
                    add: (e) => {
                        return this.jqEventChain(element.add(e), off);
                    }
                };
            }
            eventChain(element, off) {
                return {
                    element: element,
                    offon: (event, callback, options) => {
                        var nOff = () => {
                            element.removeEventListener(event, callback, options);
                        };
                        element.addEventListener(event, callback, options);
                        this.offEvents.push(nOff);
                        return this.eventChain(element, () => { off(); nOff(); });
                    },
                    off: off
                };
            }
            callInternals(callback) {
                for (var i = 0; i < this.baseInternals.length; i++) {
                    callback(this.baseInternals[i]);
                }
            }
            registerBaseInternal(instance) {
                this.baseInternals.push(instance);
                return this.eventRaiser;
            }
            event(element) {
                if (CS.Is(element, HTMLElement) || CS.Is(element, Document) || CS.Is(element, Window))
                    return this.eventChain(element, () => { });
                if (CS.Is(element, jQuery))
                    return this.jqEventChain(element, () => { });
                return this.eventChain(element, () => { });
            }
        }
        Controls.VideoPlayer = VideoPlayer;
        (function (VideoPlayer) {
            VideoPlayer.controlExt = "video-player";
            class Events {
                static ChapiterMenuToggle(param) {
                    Controls.RegisterEvent(VideoPlayer, EventNames.ChapiterMenuToggle, param);
                }
                static ControlsVisibilityChange(param) {
                    Controls.RegisterEvent(VideoPlayer, EventNames.ControlsVisibilityChange, param);
                }
                static ControlsVisibilityChanged(param) {
                    Controls.RegisterEvent(VideoPlayer, EventNames.ControlsVisibilityChanged, param);
                }
                static FullscreenChange(param) {
                    Controls.RegisterEvent(VideoPlayer, EventNames.FullscreenChange, param);
                }
                static ChapitersLoaded(param) {
                    Controls.RegisterEvent(VideoPlayer, EventNames.ChapitersLoaded, param);
                }
                static VideoLoaded(param) {
                    Controls.RegisterEvent(VideoPlayer, EventNames.VideoLoaded, param);
                }
            }
            VideoPlayer.Events = Events;
            class EventNames {
            }
            EventNames.ChapiterMenuToggle = `${VideoPlayer.controlExt}-chapiter-menu-toggle`;
            EventNames.ControlsVisibilityChange = `${VideoPlayer.controlExt}-controls-visibility-change`;
            EventNames.ControlsVisibilityChanged = `${VideoPlayer.controlExt}-controls-visibility-changed`;
            EventNames.FullscreenChange = `${VideoPlayer.controlExt}-fullscreen-change`;
            EventNames.ChapitersLoaded = `${VideoPlayer.controlExt}-chapiters-loaded`;
            EventNames.VideoLoaded = `${VideoPlayer.controlExt}-video-loaded`;
            VideoPlayer.EventNames = EventNames;
        })(VideoPlayer = Controls.VideoPlayer || (Controls.VideoPlayer = {}));
        var EventNames = VideoPlayer.EventNames;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=VideoPlayer.js.map
